import { FC } from 'react';
import { Tooltip } from '../../components/ui/tooltip';
import { BandaidsIcon } from '@phosphor-icons/react';
import { IActiveInjurySummary } from '../../models/injury';
import { INJURY_BODY_ZONE_ABBR, INJURY_BODY_ZONE_LABEL } from '../../enums/injuries';
import styles from './InjuryBadge.module.scss';

interface InjuryBadgeProps {
  injury: IActiveInjurySummary;
  size?: 'sm' | 'md';
}

export const InjuryBadge: FC<InjuryBadgeProps> = ({ injury, size = 'md' }) => {
  const abbr = INJURY_BODY_ZONE_ABBR[injury.bodyZone] ?? injury.bodyZone.toUpperCase().slice(0, 4);
  const label = INJURY_BODY_ZONE_LABEL[injury.bodyZone] ?? injury.bodyZone;

  const isRtp = injury.rtpPhase != null;

  const tooltipContent = (
    <div className={styles.tooltip}>
      <p className={styles.tooltipTitle}>{isRtp ? `RTP Fase ${injury.rtpPhase}/4` : 'Infortunato'}</p>
      <p className={styles.tooltipLine}><span className={styles.tooltipKey}>Zona:</span> {label}</p>
      <p className={styles.tooltipLine}><span className={styles.tooltipKey}>Gravità:</span> {injury.severity}</p>
      {injury.daysOut != null && (
        <p className={styles.tooltipLine}><span className={styles.tooltipKey}>Giorni out:</span> {injury.daysOut}gg</p>
      )}
      {injury.expectedReturnDate && (
        <p className={styles.tooltipLine}>
          <span className={styles.tooltipKey}>Ritorno prev.:</span>{' '}
          {new Date(injury.expectedReturnDate).toLocaleDateString('it-IT')}
        </p>
      )}
    </div>
  );

  return (
    <Tooltip content={tooltipContent}>
      <span className={[styles.badge, isRtp ? styles.rtp : styles.injured, styles[size]].join(' ')}>
        <BandaidsIcon size={size === 'sm' ? 10 : 12} weight="bold" />
        {isRtp ? `RTP F${injury.rtpPhase}/4` : `INF ${abbr}${injury.daysOut != null ? ` · ${injury.daysOut}gg` : ''}`}
      </span>
    </Tooltip>
  );
};

export default InjuryBadge;
